const burgerMenu = document.querySelector('[data-mobile-trigger]');
const menu = document.querySelector('.site-header__menu');

burgerMenu.addEventListener('click', function(e) {
    
    burgerMenu.classList.toggle('site-header__menu-button--open');
    
    menu.classList.toggle('site-header__menu--show');
    
    setTimeout(function() {
        document.documentElement.classList.toggle('menu-opening');
    }, 100);
        
});